import React from 'react';
import { Link } from 'react-router-dom';

// Components
import * as icons from './Icons/Icons';

class NotFound extends React.Component {
  render() {
    return(
      <main className="page page--error wrap">
        <div className="panel--brief">
          <i className="page--error__icon"><icons.iconChainBroken /></i>
          <h1 className="panel__title">Page not found</h1>
          <p>Sorry, the page you’re trying to reach does not exist. You may have mistyped the URL, or the page may have been removed.</p>
          <Link className="btn--outline" to="/">Return to Dashboard</Link>
        </div>
      </main>
    )
  }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/app/components/NotFound.js